import PropTypes from 'prop-types';

const TableHeader = {
  Header: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  Cell: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.node]),
  accessor: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  columnWidth: PropTypes.number,
  id: PropTypes.string,
  sortType: PropTypes.string,
  unsortable: PropTypes.bool,
};

export const TableHeaderShape = PropTypes.shape(TableHeader);
export const TableHeaderExact = PropTypes.exact(TableHeader);
